import PhotosIcon from '@material-ui/icons/Photo';
import PhotosList from './photosList';
import PhotosShow from './photosShow';

export default {
  list: PhotosList,
  show: PhotosShow,
  icon: PhotosIcon,
};
